let windTop = 0;

export default function(params) {

    function lockScroll()
    {
        windTop = window.pageYOffset;
        document.documentElement.classList.add("no-scroll");
        document.documentElement.style.top = -windTop+'px';
        window.scrollLocked = true;
    }

    function unlockScroll() {
        document.documentElement.classList.remove("no-scroll");
        document.documentElement.style.top = 0;
        window.scrollTo(0,windTop);
        window.scrollLocked = false;
    }

    if(params === 1){
        lockScroll();
    }
    else{
        unlockScroll();
    }
}
